/**
 * Compute hierarchical question numbers for a survey's ordered question list.
 *
 * Rules:
 *  - Section headers are numbered sequentially: "1", "2", "3" …
 *  - Questions inside a section are numbered "<section>.<n>": "1.1", "1.2" …
 *  - Questions before the first section header are numbered "1", "2", "3" …
 *  - Welcome / Thank You / rich_text_block / image_display / page_break /
 *    confirmation blocks are NOT numbered (returns null for those entries).
 *  - Tolerant of both naming conventions:
 *      • builder docs ({ id, type })
 *      • QA / report docs ({ question_id, question_type })
 *
 * @param {Array<object>} questions  Ordered question list.
 * @returns {Object<string, string|null>}  Map of question id → display label.
 */
export function computeQuestionNumbers(questions) {
  const NON_NUMBERED = new Set([
    'welcome', 'thank_you', 'rich_text_block', 'image_display',
    'page_break', 'confirmation',
  ]);
  const out = {};
  let preNum = 0;
  let sectionNum = 0;
  let qInSection = 0;
  let inSection = false;
  for (const q of questions || []) {
    if (!q) continue;
    const qid = q.id || q.question_id;
    if (!qid) continue;
    const qtype = q.type || q.question_type;
    if (NON_NUMBERED.has(qtype)) {
      out[qid] = null;
      continue;
    }
    if (qtype === 'section_header') {
      sectionNum += 1;
      qInSection = 0;
      inSection = true;
      out[qid] = String(sectionNum);
      continue;
    }
    if (inSection) {
      qInSection += 1;
      out[qid] = `${sectionNum}.${qInSection}`;
    } else {
      preNum += 1;
      out[qid] = String(preNum);
    }
  }
  return out;
}
